import type { MarketUpdated, OutcomeUpdated } from '@sunflower-games/predictions-realtime-contracts';

/** "This outcome has settled/closed" off a public `outcome_updated` event. */
export function isOutcomeSettled(e: OutcomeUpdated): boolean {
  return e.isSettled || e.tradingStatusString === 'Closed';
}

/** "This market has settled" off a public `market_updated` event. */
export function isMarketSettled(e: MarketUpdated): boolean {
  return e.isSettled;
}
